import { render } from "./CustomRouteFormTemplateComponent.vue?vue&type=template&id=21353a33&ts=true"
import script from "./CustomRouteFormTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./CustomRouteFormTemplateComponent.vue?vue&type=script&lang=ts"

import "./CustomRouteFormTemplateComponent.vue?vue&type=style&index=0&id=21353a33&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__